import {
  Component,
  ViewChild,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { ModalComponent } from "../../components/modal/modal.component";

@Component({
  selector: "lowy-report-columns-modal",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline">Select Columns</div>
        <div class="subheading">Select columns to view in the report grid.</div>
        <div class="seperator"></div>

        <div class="row">
          <div class="col-6">
            <h4>V4 Sheets</h4>
            <div *ngFor="let col of allV4Cols" class="checkbox-row">
              <mat-checkbox
                [checked]="isSelected(col, 'v4')"
                (change)="toggleSelection(col, 'v4')"
                >{{ col }}</mat-checkbox
              >
            </div>
          </div>
          <div class="col-6">
            <h4>Image Types</h4>
            <div *ngFor="let col of allImageCols" class="checkbox-row">
              <mat-checkbox
                [checked]="isSelected(col, 'image')"
                (change)="toggleSelection(col, 'image')"
                >{{ col }}</mat-checkbox
              >
            </div>
          </div>
        </div>

        <div class="seperator"></div>
        <div class="button-row">
          <span (click)="cancel()">cancel</span>
          <span (click)="save()">save</span>
        </div>
      </div>
    </lowy-modal>
  `,
  styles: [
    `
      .seperator {
        margin: 15px 0;
        border-bottom: 1px solid #eee;
      }
      .checkbox-row {
        margin-bottom: 5px;
      }
      h4 {
        margin-top: 0;
      }
      .button-row {
        text-align: right;
      }
      .button-row span {
        padding: 8px 16px;
        cursor: pointer;
        text-transform: uppercase;
      }
    `,
  ],
})
export class ReportColumnsModalComponent {
  @ViewChild("modal") modal: ModalComponent;

  @Input() allImageCols: string[];
  @Input() allV4Cols: string[];

  tempSelectedImageCols: string[] = [];
  tempSelectedV4Cols: string[] = [];

  @Output()
  saveColumns = new EventEmitter<{ imageCols: string[]; v4Cols: string[] }>();

  public open(selectedImageCols: string[], selectedV4Cols: string[]) {
    this.tempSelectedImageCols = [...selectedImageCols];
    this.tempSelectedV4Cols = [...selectedV4Cols];
    this.modal.open();
  }

  isSelected(col: string, type: "image" | "v4"): boolean {
    if (type === "image") {
      return this.tempSelectedImageCols.includes(col);
    } else {
      return this.tempSelectedV4Cols.includes(col);
    }
  }

  toggleSelection(col: string, type: "image" | "v4") {
    const list =
      type === "image" ? this.tempSelectedImageCols : this.tempSelectedV4Cols;
    const index = list.indexOf(col);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(col);
    }
  }

  save() {
    this.saveColumns.emit({
      imageCols: this.tempSelectedImageCols,
      v4Cols: this.tempSelectedV4Cols,
    });
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/report-builder/report-columns-modal.component.ts